import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import WordMeaningDialog from './WordMeaningDialog';
// Presentation only. The protected meaning selection, source attribution and close behavior stay in WordMeaningDialog.
export default function MeaningPresentation({word,onClose,aboveDialog=false}){
 const [heading,setHeading]=useState(null);
 useEffect(()=>{setHeading(document.getElementById('word-meaning-title')?.parentElement||null);},[word]);
 return <>{aboveDialog?createPortal(<WordMeaningDialog word={word} onClose={onClose} layer={1400}/>,window.KELIMO_OVERLAY_HOST||document.body):<WordMeaningDialog word={word} onClose={onClose}/>}{heading&&createPortal(<span className="meaning-letter-tiles" aria-hidden="true">{[...word].map((letter,index)=><span key={index}>{letter}</span>)}</span>,heading)}</>;
}
